<template>
  <div class="contact-item contact-item_tel">
    <div class="contact-item_head">
      <div class="contact-item_icon">
        <img src="/image/contact-icon_tel.png" alt="" />
      </div>
      <p class="contact-item_title">お電話でのお問い合わせ</p>
    </div>
    <div class="contact-tel">
      <div class="contact-tel_icon">
        <img src="/image/icon_fd.png" alt="フリーダイヤル" />
      </div>
      <a :href="`tel:${HEADQUARTERS_FREEDIAL_TELEPHONE_NUMBER}`">
        <p class="contact-tel_num">{{ HEADQUARTERS_FREEDIAL_TELEPHONE_NUMBER }}</p>
      </a>
    </div>
    <p class="contact-tel_hours">
      受付時間 / 平日10:00–18:30<span class="contact-tel_note">（土日祝休業）</span>
    </p>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `contact-box` のうち「お電話でのお問い合わせ」の1枚。
 * `OrganismsLayoutsContactBox` の左半分で、ログイン画面のロック時にはこれだけを単体で出す。
 */
import { HEADQUARTERS_FREEDIAL_TELEPHONE_NUMBER } from '@/consts/BusinessConst';
</script>
